import * as React from "react";
import get from "lodash/get";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { interpolate } from "../../utils/string";

export interface ValueDuringTimeframeProps extends ComponentBaseProps {
  classNames: string;
  name: string;
  label: string;
  style?: React.CSSProperties;
  customText?: string;
  notAuthenticatedStyle?: React.CSSProperties;
  notAuthenticatedText?: string;

  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
  testMode?: string;
}

export class ValueDuringTimeframe extends ComponentBase<ValueDuringTimeframeProps> {
  renderNotAuthenticated = () => {
    return <div>{this.props.notAuthenticatedText || ""}</div>;
  };

  renderValueDuringTimeframe = () => {
    const { data, customText } = this.props;

    const interpolatedString = interpolate(customText || "", {
      ...data,
    });

    return (
      <div>
        <span className="Text-markdown-container">
          <ReactMarkdown skipHtml={true} linkTarget="_blank" plugins={[gfm]}>
            {interpolatedString}
          </ReactMarkdown>
        </span>
      </div>
    );
  };

  render() {
    const { classNames, data, isLoading, isEditing, style, testMode } =
      this.props;
    const isCustomerAuthenticated = get(data, "customer.authenticated", false);

    if (isEditing) {
      const notAuthenticated = testMode === "notAuthenticated";
      const valueDuringTimeframe = testMode === "default" || !testMode;

      return (
        <div
          id={this.props.configName}
          onDragStart={this.onDragStart}
          onMouseDown={this.onMouseDown}
          className={`MemberTier-container  ${classNames || ""}`}
          ref={(component) => (this.component = component)}
          style={style}
        >
          {notAuthenticated && this.renderNotAuthenticated()}
          {valueDuringTimeframe && this.renderValueDuringTimeframe()}
        </div>
      );
    }

    if (isLoading) {
      return "...";
    }

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        ref={(component) => (this.component = component)}
        style={style}
      >
        {!isCustomerAuthenticated && this.renderNotAuthenticated()}
        {isCustomerAuthenticated && this.renderValueDuringTimeframe()}
      </div>
    );
  }
}
